const Text = ({children, type = "body", classNames = null}) =>{

    const textTypes = {
        webtitle: "text-5xl font-bold",
        webtitletwo: "text-5xl font-bold",
        maintitle: "text-3xl font-bold",
        main: "text-3xl",
        buttontext: "text-lg md:text-xl lg:text-2xl font-medium",
        itemmain: "text-2xl font-bold",
        itemtext: "text-2xl font-medium",
        orderitem: "text-xl font-medium",
        title: "text-2xl font-bold tracking-wide",
        subtitle: "text-lg text-gray-600",
        body: "text-base text-gray-800",
        boldbody: "text-lg font-bold text-gray-600",
        caption: "text-sm text-gray-500 italic",
        button: "uppercase text-sm font-medium tracking-wider",
    }

    // SEO IMPORTANT: these Tags are important for Google SEO but dont affect visuals
    const tagMapping = {
        webtitle: "h1",
        webtitletwo: "h2",
        maintitle: "h2",
        main: "p",
        title: "h3",
        subtitle: "h4",
        body: "p",
        caption: "small"
    }

    const Tag  = tagMapping[type] ?? "span"

    const classes = `${textTypes[type] ?? ""} ${classNames}`.trim()
    const MainView = () =>(
        <Tag className={classes} style={{ userSelect: 'none' }}>{children}</Tag>
    )
    return MainView()
}

export default Text